OT.createNS('OT.Redesign.Views.Results.DeliveryButton');

OT.Redesign.Views.Results.DeliveryButton = Backbone.ViewManager.BaseView.extend({
    template: "Redesign/Results/_Delivery",

    events: {
        'click .rest-row-delivery__button': 'sendClickEvent',
    },
    
    sendClickEvent: function() {
        window.OTDataLayer.push({ event: 'delivery_partner_click_search' });
    }
})